import { useInView } from '@hooks/useInView';
import * as React from 'react';
import S from './SectionWrapper.styles';
import { rootMargin } from '@helpers/animation';
const SectionWrapper = React.forwardRef(({ children, className, flush = 'none', fullWidth = false, id, innerWidth = 'default', spacing = 'margin', ...otherProps }, ref) => {
    const [inViewRef, active] = useInView({
        rootMargin,
    });
    return (React.createElement(React.Fragment, null,
        id && React.createElement(S.ScrollAnchor, { id: id }),
        React.createElement(S.Container, { ref: (r) => {
                // Handle forwarded ref.
                if (typeof ref === 'function') {
                    ref(r);
                }
                else if (ref) {
                    ref.current = r;
                }
                // Handle internal refs.
                inViewRef.current = r;
            }, className: className, flush: flush, spacing: spacing, "data-active": active, ...otherProps }, fullWidth ? children : React.createElement(S.SiteWide, { width: innerWidth }, children))));
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
